import { useEffect, useState } from 'react';
import axios from '../../../axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import usePermisos from '../../../hooks/usePermisos';
import NoPermissions from '../../NoPermissions/NoPermissions';

// ID PARA EL ESTADO DE JALISCO
const estadoId = 14;

const PERMISOS_REQUERIDOS = ['patient_update', 'patient_read'];

const EditClientes = () => {
    const  {clienteId} = useParams();
    const navigate = useNavigate();
    const [cliente, setCliente] = useState({
        nombre: '',
        direccion: '',
        cp: '',
        ciudad: '',
        fecha_nacimiento: '',
        telefono: '',
        celular: '',
        email: '',
        rfc: '',
    });
    const [ciudades, setCiudades] = useState([]);
    const [validate, setValidate] = useState({
        nombre: true,
        direccion: true,
        cp: true,
        ciudad: true,
        fecha_nacimiento: true,
        email: true,
        telefono: true,
    });

    const { permisos, loading: loadingPermisos, tienePermiso } = usePermisos(PERMISOS_REQUERIDOS);

    useEffect(() => {
        axios
            .get(`api/municipalities-by-state/${estadoId}`)
            .then((resp) => {
                setCiudades(resp.data);
            })
            .catch((e) => console.log('Error: ', e));
    }, []);

    useEffect(()=>{
        axios.get(`api/patients/${clienteId}`).then((resp)=>{
            setCliente(resp.data)
        }).catch(e=>console.log(e))
    },[clienteId])

    const _editcliente = (e) => {
        e.preventDefault();

        if (!tienePermiso('patient_update')) return;

        axios
            .put(`api/patients/${clienteId}`, cliente)
            .then((resp) => {
                alert('Cliente actualizado exitosamente');
                navigate('/admin/clientes');
            })
            .catch((e) => {
                if (e.response?.data?.errors) {
                    let errors = e.response.data.errors;
                    setValidate({
                        nombre: !errors.nombre,
                        direccion: !errors.direccion,
                        cp: !errors.cp,
                        ciudad: !errors.ciudad,
                        fecha_nacimiento: !errors.fecha_nacimiento,
                        celular: !errors.celular,
                        email: !errors.email,
                        telefono: !errors.telefono,
                    });
                    alert(e.response.data.message || 'Error al actualizar el cliente');
                }
            });
    };

    if (loadingPermisos) {
        return (
            <div className="flex items-center justify-center h-64">
                <span className="text-gray-400">Cargando...</span>
            </div>
        );
    }

    if (!tienePermiso('patient_update')) {
        return (
            <div>
                <div className="container-admin-menu">
                    <Breadcrumb />
                </div>
                <div className="container-admin-container">
                    <NoPermissions />
                </div>
            </div>
        );
    }

    return (
        <>
            <div className='container-admin-menu'> <Breadcrumb /> </div>
            <div className='container-admin-container'>
                <div className='container-admin bg-white rounded-lg shadow-md'>
                    {/* Header */}
                    <div className='info-badge flex items-center gap-3 p-5 border-b border-gray-100'>
                        <div className='shrink-0 w-9 h-9 rounded-full border-2 border-white shadow-md overflow-hidden'>
                            <img className='w-full h-full object-cover rounded-full' src='/images/paciente.png' alt='dento metric' />
                        </div>
                        <h5 className='flex-1 text-xl font-bold'>EDITAR - Datos de el Paciente</h5>
                        <Link to="../clientes" className='text-sm text-[#03f] hover:underline'>
                            Regresar
                        </Link>
                    </div>

                    {/* Formulario */}
                    <form onSubmit={_editcliente} className="grid grid-cols-12 gap-4 px-5 pb-5 pt-4">
                        {/* Nombre completo */}
                        <div className="col-span-12">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="name" className="text-sm font-medium text-gray-600">
                                    Nombre completo *
                                </label>
                                <input
                                    id="name"
                                    type="text"
                                    className="dento-input"
                                    value={cliente.nombre}
                                    onChange={(e) => setCliente({ ...cliente, nombre: e.target.value })}
                                />
                                {!validate.nombre && (
                                    <span className="text-sm text-red-500">El nombre completo es obligatorio</span>
                                )}
                            </div>
                        </div>

                        {/* Dirección */}
                        <div className="col-span-12 md:col-span-10">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="direccion" className="text-sm font-medium text-gray-600">
                                    Dirección *
                                </label>
                                <input
                                    id="direccion"
                                    type="text"
                                    className="dento-input"
                                    value={cliente.direccion}
                                    onChange={(e) => setCliente({ ...cliente, direccion: e.target.value })}
                                />
                                {!validate.direccion && (
                                    <span className="text-sm text-red-500">La dirección es obligatoria</span>
                                )}
                            </div>
                        </div>

                        {/* Código Postal */}
                        <div className="col-span-12 md:col-span-2">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="cp" className="text-sm font-medium text-gray-600">
                                    C.P. *
                                </label>
                                <input
                                    id="cp"
                                    type="text"
                                    className="dento-input"
                                    value={cliente.cp}
                                    onChange={(e) => setCliente({ ...cliente, cp: e.target.value })}
                                />
                                {!validate.cp && (
                                    <span className="text-sm text-red-500">El código postal es obligatorio</span>
                                )}
                            </div>
                        </div>

                        {/* Ciudad */}
                        <div className="col-span-12 md:col-span-3">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="ciudad" className="text-sm font-medium text-gray-600">
                                    Ciudad *
                                </label>
                                <select
                                    id="ciudad"
                                    className="dento-input browser-default"
                                    value={cliente.ciudad}
                                    onChange={(e) => setCliente({ ...cliente, ciudad: e.target.value })}
                                >
                                    <option value="">Seleccione la ciudad</option>
                                    {ciudades.map((ciudad) => (
                                        <option key={ciudad.id} value={ciudad.description}>
                                            {ciudad.description}
                                        </option>
                                    ))}
                                </select>
                                {!validate.ciudad && (
                                    <span className="text-sm text-red-500">La ciudad es obligatoria</span>
                                )}
                            </div>
                        </div>

                        {/* Fecha Nacimiento */}
                        <div className="col-span-12 md:col-span-3">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="fNacimiento" className="text-sm font-medium text-gray-600">
                                    Fecha Nacimiento *
                                </label>
                                <input
                                    id="fNacimiento"
                                    type="date"
                                    className="dento-input"
                                    value={cliente.fecha_nacimiento}
                                    onChange={(e) => setCliente({ ...cliente, fecha_nacimiento: e.target.value })}
                                />
                                {!validate.fecha_nacimiento && (
                                    <span className="text-sm text-red-500">La fecha de nacimiento es obligatoria</span>
                                )}
                            </div>
                        </div>

                        {/* Celular */}
                        <div className="col-span-12 md:col-span-3">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="celular" className="text-sm font-medium text-gray-600">
                                    Celular
                                </label>
                                <input
                                    id="celular"
                                    type="number"
                                    className="dento-input"
                                    value={cliente.celular}
                                    onChange={(e) => setCliente({ ...cliente, celular: e.target.value })}
                                />
                            </div>
                        </div>

                        {/* Teléfono */}
                        <div className="col-span-12 md:col-span-3">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="telefono" className="text-sm font-medium text-gray-600">
                                    Teléfono
                                </label>
                                <input
                                    id="telefono"
                                    type="number"
                                    className="dento-input"
                                    value={cliente.telefono}
                                    onChange={(e) => setCliente({ ...cliente, telefono: e.target.value })}
                                />
                            </div>
                        </div>

                        {/* Email */}
                        <div className="col-span-12 md:col-span-6">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="email" className="text-sm font-medium text-gray-600">
                                    Email
                                </label>
                                <input
                                    id="email"
                                    type="email"
                                    className="dento-input"
                                    value={cliente.email}
                                    onChange={(e) => setCliente({ ...cliente, email: e.target.value })}
                                />
                                {!validate.email && (
                                    <span className="text-sm text-red-500">El email no es válido</span>
                                )}
                            </div>
                        </div>

                        {/* RFC */}
                        <div className="col-span-12 md:col-span-6">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="rfc" className="text-sm font-medium text-gray-600">
                                    RFC
                                </label>
                                <input
                                    id="rfc"
                                    type="text"
                                    maxLength={19}
                                    className="dento-input"
                                    value={cliente.rfc}
                                    onChange={(e) => setCliente({ ...cliente, rfc: e.target.value })}
                                />
                            </div>
                        </div>

                        {/* Botón Submit */}
                        <div className="col-span-12 flex justify-end mt-2">
                            <button
                                className="flex items-center gap-2 px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
                                type="submit"
                            >
                                Actualizar datos
                                <i className="material-icons text-base">save</i>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default EditClientes;